import Vue from 'vue';
import Router from 'vue-router';
import { sync } from 'vuex-router-sync';

import store from '@/core/store';

Vue.use(Router);

const appRoutes = [
  {
    name: 'home',
    path: '/home',
    redirect: { name: 'colors-index' },
  },
  {
    name: 'components-index',
    path: '/components',
    redirect: { name: 'colors-index' },
  },
  {
    name: 'content-card-index',
    path: '/components/content-card',
    component: () => import('@/views/ContentCardRoute'),
  },
  {
    name: 'colors-index',
    path: '/colors',
    component: () => import('@/views/ColorsRoute'),
  },
  {
    name: 'ui-index',
    path: '/ui',
    redirect: { name: 'ui-typography' },
  },
  {
    name: 'ui-typography',
    path: '/ui/typography',
    component: () => import('@/views/UIIndexRoute'),
  },
  {
    name: 'ui-buttons',
    path: '/ui/buttons',
    component: () => import('@/views/UIButtonsRoute'),
  },
  {
    name: 'ui-inputs',
    path: '/ui/inputs',
    component: () => import('@/views/UIInputsRoute'),
  },
  {
    name: 'ui-icons',
    path: '/ui/icons',
    component: () => import('@/views/UIIconsRoute'),
  },
  {
    name: 'ui-modals',
    path: '/ui/modals',
    component: () => import('@/views/UIModalsRoute'),
  },
  {
    name: 'ui-flashs',
    path: '/ui/flashs',
    component: () => import('@/views/UIFlashRoute'),
  },
  {
    name: 'focus',
    path: '/focus',
    component: () => import('@/views/FocusRoute'),
  },
  {
    path: '*',
    redirect: { name: 'home' },
  },
];

const router = new Router({
  mode: 'history',
  routes: appRoutes,
  scrollBehavior (to, from, savedPosition) {
    if (to.name && from && to.name === from.name) {
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

sync(store, router);

router.afterEach(async (to, from) => {
  window._$previousRoute = from;
});
export default router;
